
<template>
  <div
    v-show="this.$store.state.layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>
  <!-- <sidenav
    class="fixed-start"
    v-if="this.$store.state.showSidenav"
  /> -->
  <sidenav
    v-if="this.$store.state.showSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
  >
    <!-- nav -->
    <navbar
      :textWhite="
        this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'
      "
      :minNav="navbarMinimize"
      v-if="this.$store.state.showNavbar"
    />
    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />
    <!-- <configurator
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : ''
      ]"
    /> -->
  </main>
</template>
<script>
import Sidenav from "../examples/Sidenav";
// import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";

export default {
  name: "App",
  components: {
    Sidenav,
    // Configurator,
    Navbar,
    AppFooter
  },
  data(){
    return{
     validaciontoken:'',
    }
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"])
  },
created() {

     this.validaciontoken = sessionStorage.getItem("token");
     if (this.validaciontoken == '' || this.validaciontoken == null) {
            this.$router.push("/");
        }
        const fecha2 = new Date().getTime();
        const fecha1 = localStorage.getItem("hora");
        const totalhora = fecha1 - fecha2;
        console.log(totalhora);
        setInterval(function () {
            // this.$router.push({ path: '/' });
            window.location.replace("http://localhost:8080");
            localStorage.clear();
            sessionStorage.clear();
        }, totalhora);
  }
};
</script>
